import { USER_PREFERENCES } from './../config';

const reducer = (state = null, action) => {
    switch (action.type) {
        case USER_PREFERENCES:
            return action.payload;
        default:
            return state;
    }
}

export default reducer;
